const gwasviz_multi_trait_conf = {
    'species': 'Pop332',
    // 默认表型及默认展示区间
    'query_trait': ['SlFM0424', 'SlFM0488', 'SlFM0521', 'SlFM0815', 'SlFM1114'],
    'query_chr': '7',
    'query_loc_start': '3000000',
    'query_loc_end': '3500000',
    // region用户输入默认值
    'region': '7:3000000-3500000'
}

export default gwasviz_multi_trait_conf
